<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50">
        <md-field :class="!checkArea(typeInfo.area) ? 'md-invalid' : ''">
          <label for="area">{{ $t("typeInfo.areaErosion") }} (ha)</label>
          <md-input type="number" step="0.01" name="area" v-model="typeInfo.area" />
          <span class="md-error">{{ $t("error.errorRange") }} (0-99999)</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <select v-model="typeInfo.erosion_type" name="erosionType">
            <option disabled value="">{{ $t("typeInfo.erosionType") }}</option>
            <option v-for="(et, key) in erosionTypeList" :value="key" :key="key">{{ et }}</option>
          </select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="frequencyList" :label="$t('typeInfo.frequency')" @btnValue="getFrequency" :editTB="typeInfo.frequency" />
      </div>
      <div class="md-layout-item md-size-100">
        <toggle-buttons :btnList="effectList" :label="$t('typeInfo.effect')" @btnValue="getEffect" :editTB="typeInfo.effect" />
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <select v-model="typeInfo.origin" name="origin">
            <option disabled value="">{{ $t("typeInfo.origin") }}</option>
            <option v-for="(o, key) in originList" :value="key" :key="key">{{ o }}</option>
          </select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <select v-model="typeInfo.trend" name="trend">
            <option disabled value="">{{ $t("typeInfo.trend") }}</option>
            <option v-for="(t, key) in trendList" :value="key" :key="key">{{ t }}</option>
          </select>
        </md-field>
      </div>
    </div>

    <error-dialog :show="error" :text="$t('error.dataCheck')" @closeError="error = false" />
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import ErrorDialog from '@/components/ErrorDialog'

import EventBus from '@/event-bus'
import { getDomain } from '@/assets/scripts/domainsManager'
import { checkArea, normalize } from '@/assets/scripts/formatData'

const FREQUENCY = 'event_frequency'
const EFFECT = 'erosion_effect'
const EROSION_TYPE = 'erosion_type'
const ORIGIN = 'erosion_origin'
const TREND = 'erosion_trend'

export default {
  name: 'Erosion',
  components: {
    ToggleButtons,
    ErrorDialog
  },
  data: () => ({
    typeInfo: {
      area: null,
      erosion_type: '',
      frequency: '',
      effect: '',
      origin: '',
      trend: ''
    },
    erosionTypeList: {},
    frequencyList: {},
    effectList: {},
    originList: {},
    trendList: {},
    edit: false,
    checkArea: checkArea,
    error: false
  }),
  mounted () {
    this.$store.state.plot.id === null ? this.edit = false : this.edit = true

    EventBus.$on('save', () => {
      this.saveData()
    })

    this.setLists()

    if (this.edit) {
      this.typeInfo = this.$store.state.plot.typeInfo // ref to store
    }
  },
  methods: {
    saveData: function () {
      if (this.checkData()) {
        if (this.typeInfo.area !== null) this.typeInfo.area = normalize(this.typeInfo.area, 2)
        this.edit ? this.$emit('typeInfo', null) : this.$emit('typeInfo', this.typeInfo)
      } else {
        this.error = true
      }
    },

    setLists: function () {
      getDomain(EROSION_TYPE).then(data => {
        this.erosionTypeList = data[this.$i18n.locale]
      })
      getDomain(FREQUENCY).then(data => {
        this.frequencyList = data[this.$i18n.locale]
      })
      getDomain(EFFECT).then(data => {
        this.effectList = data[this.$i18n.locale]
      })
      getDomain(ORIGIN).then(data => {
        this.originList = data[this.$i18n.locale]
      })
      getDomain(TREND).then(data => {
        this.trendList = data[this.$i18n.locale]
      })
    },

    getFrequency: function (value) {
      this.typeInfo.frequency = value
    },

    getEffect: function (value) {
      this.typeInfo.effect = value
    },

    checkData: function () {
      return checkArea(this.typeInfo.area)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
